export const routeConfig = {
  ADMIN_ADMIN_LIST_ROUTE: ["admin:read"],

  ROLE_LIST_ROUTE: ["role:read"],

  MODULE_LIST_ROUTE: ["module:read"],

  PERMISSION_LIST_ROUTE: ["permission:read"],

  USER_PROFILE_LIST_ROUTE: ["profile:read"],

  BLOG_LIST_ROUTE: ["blog:read"],
  BLOG_UPDATE_ROUTE: ["blog:edit"],
  BLOG_ADD_ROUTE: ["blog:create"],

  CONTENT_LIST_ROUTE: ["admin:read"],
  CONTENT_ADD_ROUTE: ["admin:create"],
  CONTENT_UPDATE_ROUTE: ["admin:edit"],

  CATEGORY_LIST_ROUTE: ["admin:read"],
  CATEGORY_ADD_ROUTE: ["admin:create"],
  CATEGORY_UPDATE_ROUTE: ["admin:edit"],

  SUB_CATEGORY_LIST_ROUTE: ["admin:read"],
  SUB_CATEGORY_ADD_ROUTE: ["admin:create"],
  SUB_CATEGORY_UPDATE_ROUTE: ["admin:edit"],

  MEDIA_LIST_ROUTE: ["media:read"],

  BLOG_AUTHOR_LIST_ROUTE: ["blogauthor:read"],

  WORKER_JOBS_LIST_ROUTE: ["admin:read"],

  PAGE_LIST_ROUTE: ["page:read"],
  HR_PAGE_LIST_ROUTE: ["hr:read"],
  COMPLIANCE_PAGE_LIST_ROUTE: ["compliance:read"],
  OPERATIONS_PAGE_LIST_ROUTE: ["operations:read"],
  MARKETING_PAGE_LIST_ROUTE: ["marketing:read"],

  PAGE_VIEW_LIST_ROUTE: ["page:edit"],

  ICON_LIST_ROUTE: ["icon:read"],

  ANNOUNCEMENT_LIST_ROUTE: ["announcement:read"],
  ANNOUNCEMENT_ADD_ROUTE: ["announcement:create"],
  ANNOUNCEMENT_UPDATE_ROUTE: ["announcement:edit"],

  PRESS_RELEASE_LIST_ROUTE: ["pressrelease:read"],
  PRESS_RELEASE_ADD_ROUTE: ["pressrelease:create"],
  PRESS_RELEASE_UPDATE_ROUTE: ["pressrelease:edit"],

  PEOPLE_LIST_ROUTE: ["people:read"],

  ROLES_EDIT_LIST_ROUTE: ["role:edit"],

  LOGIN_LIST_ROUTE: [],

  FORGET_PASSWORD_LIST_ROUTE: [],

  RESET_PASSWORD_LIST_ROUTE: [],

  LOGOUT_LIST_ROUTE: [],

  CONTACT_US_LIST_ROUTE: ["contactus:read"],
  CUSTOMER_LIST_ROUTE: ["contactus:read"],

  PODCAST_ADD_ROUTE: ["podcast:create"],
  PODCAST_UPDATE_ROUTE: ["podcast:edit"],
  PODCAST_LIST_ROUTE: ["podcast:read"],

  INDEX_LIST_ROUTE: ["index:read"],
  INDEX_UPDATE_ROUTE: ["index:read"],
  INDEX_ADD_ROUTE: ["index:create"],

  EDITABLE_LIST_ROUTE: ["editable:read"],
  EDITABLE_ADD_ROUTE: ["editable:create"],
  EDITABLE_UPDATE_ROUTE: ["editable:edit"],

  NEWS_ADD_ROUTE: ["news:create"],
  NEWS_LIST_ROUTE: ["news:read"],
  NEWS_UPDATE_ROUTE: ["news:edit"],

  HEADER_LIST_ROUTE: ["admin:read"],
  HEADER_ADD_ROUTE: ["header:create"],
  HEADER_UPDATE_ROUTE: ["header:edit"],

  JOB_LIST_ROUTE: ["job:read"],
  JOB_ADD_ROUTE: ["job:read"],
  JOB_UPDATE_ROUTE: ["job:edit"],

  NOTICE_LIST_ROUTE: ["notice:read"],
  NOTICE_ADD_ROUTE: ["notice:create"],
  NOTICE_UPDATE_ROUTE: ["notice:edit"],

  DASHBOARD_LIST_ROUTE: ["dashboard:read"],
  DASHBOARD_ADD_ROUTE: ["dashboard:create"],
  DASHBOARD_UPDATE_ROUTE: ["dashboard:edit"],

  INDEX_UPLOAD_LIST_ROUTE: ["indexupload:read"],
  INDEX_UPLOAD_ADD_ROUTE: ["indexupload:create"],
  INDEX_UPLOAD_UPDATE_ROUTE: ["indexupload:read"],

  JOB_APPLICATION_LIST_ROUTE: ["jobapplication:read"],
  JOB_APPLICATION_ADD_ROUTE: ["jobapplication:create"],

  JOB_APPLICATION_UPDATE_ROUTE: ["jobapplication:edit"],

  ADDITIONAL_HTML_LIST_ROUTE: ["additionalhtml:read"],
  ADDITIONAL_HTML_ADD_ROUTE: ["additionalhtml:create"],
  ADDITIONAL_HTML_UPDATE_ROUTE: ["additionalhtml:edit"],

  BLOG_CATEGORY_LIST_ROUTE: ["blogcategory:read"],
  AUDIT_LOG_LIST_ROUTE: ["auditlog:read"],
};

export const ADMIN_ADMIN_LIST_ROUTE = "/admin";

export const AUDIT_LOG_LIST_ROUTE = "/auditlog";

export const NOTICE_LIST_ROUTE = "/notice";

export const BLOG_CATEGORY_LIST_ROUTE = "/blog-category";

export const ADDITIONAL_HTML_LIST_ROUTE = "/additional-html";

export const INDEX_UPLOAD_LIST_ROUTE = "/indexupload";

export const EDITABLE_LIST_ROUTE = "/editable";
export const EDITABLE_ADD_ROUTE = "/editable/editable-add";
export const EDITABLE_UPDATE_ROUTE = "/editable/:id/update";

export const JOB_APPLICATION_LIST_ROUTE = "/jobapplication";

export const DASHBOARD_LIST_ROUTE = "/";

export const JOB_LIST_ROUTE = "/job";
export const JOB_ADD_ROUTE = "/job/add-job";
export const JOB_UPDATE_ROUTE = "/job/:id/update";
export const WORKER_JOBS_LIST_ROUTE = "/workerjobs";

export const HEADER_LIST_ROUTE = "/header-footer";
export const HEADER_ADD_ROUTE = "/header/header-add";
export const HEADER_UPDATE_ROUTE = "/header Footer";

export const ROLE_LIST_ROUTE = "/roles";
export const PODCAST_LIST_ROUTE = "/content/podcast";
export const PODCAST_ADD_ROUTE = "/content/add-podcast";
export const PODCAST_UPDATE_ROUTE = "/content/podcast/:id/update";

export const CONTENT_LIST_ROUTE = "/content/content-list";
export const CONTENT_ADD_ROUTE = "/content/content-add";
export const CONTENT_UPDATE_ROUTE = "/content/:id/update";

export const CATEGORY_LIST_ROUTE = "/content/content-list/category-list";
export const CATEGORY_ADD_ROUTE = "/content/content-list/category-add";
export const CATEGORY_UPDATE_ROUTE = "/content-list/category/:id/update";

export const SUB_CATEGORY_LIST_ROUTE = "/content/content-list/sub-categroy-list";
export const SUB_CATEGORY_ADD_ROUTE = "/content/content-list/sub-category-add";
export const SUB_CATEGORY_UPDATE_ROUTE = "/content-list/sub-category/:id/update";

export const NEWS_ADD_ROUTE = "/content/add-news";
export const NEWS_LIST_ROUTE = "/content/news";
export const NEWS_UPDATE_ROUTE = "/content/news/:id/update";

export const MODULE_LIST_ROUTE = "/modules";

export const PERMISSION_LIST_ROUTE = "/permissions";

export const USER_PROFILE_LIST_ROUTE = "/profile";

export const BLOG_LIST_ROUTE = "/blog";
export const BLOG_ADD_ROUTE = "/blog/add-blog";
export const BLOG_UPDATE_ROUTE = "/blog/:id/update";

export const MEDIA_LIST_ROUTE = "/media";

export const BLOG_AUTHOR_LIST_ROUTE = "/blogauthor";

export const PAGE_LIST_ROUTE = "/page";
export const HR_PAGE_LIST_ROUTE = "/hr-pages";
export const COMPLIANCE_PAGE_LIST_ROUTE = "/compliance-pages";
export const OPERATIONS_PAGE_LIST_ROUTE = "/operations-pages";
export const MARKETING_PAGE_LIST_ROUTE = "/marketing-pages";

export const PAGE_VIEW_LIST_ROUTE = "/page/:pageId/view";

export const ICON_LIST_ROUTE = "/icon";

export const ANNOUNCEMENT_LIST_ROUTE = "/announcement";
export const ANNOUNCEMENT_ADD_ROUTE = "/announcement/add-announcement";
export const ANNOUNCEMENT_UPDATE_ROUTE = "/announcement/:id/update";

export const PRESS_RELEASE_LIST_ROUTE = "/pressrelease";
export const PRESS_RELEASE_ADD_ROUTE = "/pressrelease/add-pressrelease";
export const PRESS_RELEASE_UPDATE_ROUTE = "/pressrelease/:id/update";

export const PEOPLE_LIST_ROUTE = "/people";

export const INDEX_LIST_ROUTE = "/index";
export const INDEX_UPDATE_ROUTE = "/index/:id/update";
export const INDEX_ADD_ROUTE = "/index/add-index";

export const ROLES_EDIT_LIST_ROUTE = "/roles/:id";
export const CONTACT_US_LIST_ROUTE = "/contactus";
export const CUSTOMER_LIST_ROUTE = "/customer";

//PUBLIC ROUTES

export const LOGIN_LIST_ROUTE = "/login";

export const FORGET_PASSWORD_LIST_ROUTE = "/forget-password";

export const RESET_PASSWORD_LIST_ROUTE = "/reset-password";

export const LOGOUT_LIST_ROUTE = "/logout";
